export default __webpack_public_path__ + "static/media/HealthInsurance.1e6bbb55.svg";